/**
 * Human-readable relative time (e.g. "2 hours ago") for past dates.
 * @param {string|number|Date} input
 * @returns {string}
 */
export function formatRelativeTime(input) {
  try {
    const d = input instanceof Date ? input : new Date(input);
    const t = d.getTime();
    if (Number.isNaN(t)) return '';

    const now = Date.now();
    let diffSec = Math.round((t - now) / 1000);
    const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });
    const abs = Math.abs(diffSec);

    if (abs < 45) return rtf.format(0, 'second');
    if (abs < 3600) return rtf.format(Math.round(diffSec / 60), 'minute');
    if (abs < 86400) return rtf.format(Math.round(diffSec / 3600), 'hour');
    if (abs < 604800) return rtf.format(Math.round(diffSec / 86400), 'day');
    if (abs < 2629800) return rtf.format(Math.round(diffSec / 604800), 'week');
    if (abs < 31557600) return rtf.format(Math.round(diffSec / 2629800), 'month');
    return rtf.format(Math.round(diffSec / 31557600), 'year');
  } catch {
    return '';
  }
}
